<template>
  <cv-content id="main-content" style="max-width: 1300px;">
    <cv-tag label="Byteliberi di Paolo Proni" kind="teal"
            style="width: 100vw; margin-bottom: 1em;"></cv-tag>
    <cv-grid fullWidth> <!-- sm: 4 md: 8 lg: 16 -->
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-text-input label="Descrizione" title="Descrizione"
                         value="Gianni Rossi s.r.l." />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="4" :lg="8">
          <cv-text-input label="Titolare" title="Titolare"  value="Gianni Rossi" />
        </cv-column>
        <cv-column :sm="2" :md="2" :lg="4">
          <cv-text-input label="Partita IVA" title="Partita IVA" value="" />
        </cv-column>
        <cv-column :sm="2" :md="2" :lg="4">
          <cv-text-input label="Codice Fiscale" title="Codice Fiscale" value="" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <h6>Domicilio Fiscale</h6>
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="3" :lg="6">
          <cv-text-input label="Via" title="Via" value="" />
        </cv-column>
        <cv-column :sm="4" :md="3" :lg="6">
          <cv-combo-box label="Seleziona un comune" title="Comune"
                        :auto-filter="true"
                        @change="cambiamento"
                        v-model="modello_comune"
                        :options="comuni"></cv-combo-box>
        </cv-column>
        <cv-column :sm="2" :md="1" :lg="2">
          <cv-text-input label="Provincia" title="Provincia" value="" readonly />
        </cv-column>
        <cv-column :sm="2" :md="1" :lg="2">
          <cv-text-input label="CAP" title="C.A.P" value="" readonly />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="3" :lg="6">
          <cv-text-input label="Mobile" title="Mobile" value="" />
        </cv-column>
        <cv-column :sm="2" :md="3" :lg="4">
          <cv-text-input label="Fisso" title="Fisso" value="" />
        </cv-column>
        <cv-column :sm="2" :md="2" :lg="6">
          <cv-text-input label="Fax" title="Fax" value="" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="email" title="email" value="" />
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="Linkedin" title="Linkedin" value="" />
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="Twitter" title="Twitter" value="" />
        </cv-column>
        <cv-column :sm="2" :md="4" :lg="4">
          <cv-text-input label="Facebook" title="Facebook" value="" />
        </cv-column>
      </cv-row>
      <cv-row>
        <cv-column :sm="4" :md="8" :lg="16">
          <cv-text-area label="Note" value=""></cv-text-area>
        </cv-column>
      </cv-row>
    </cv-grid>

    <hr/>
    <Bottoniera testo_nuovo="Nuovo Terzista"
                testo_salva="Salva Terzista"
                :stato="this.$statiPossibili.non_modificato"
                v-on:salva-premuto="$emit('bottone-premuto')"
                v-on:nuovo-premuto="$emit('bottone-premuto')"
                v-on:duplica-premuto="$emit('bottone-premuto')"
                v-on:primo-premuto="$emit('bottone-premuto')"
                v-on:precedente-premuto="$emit('bottone-premuto')"
                v-on:successivo-premuto="$emit('bottone-premuto')"
                v-on:ultimo-premuto="$emit('bottone-premuto')"
                v-on:visualizzazione-premuto="$emit('bottone-premuto')"
                v-on:filtra-premuto="$emit('bottone-premuto')"
                v-on:cancella-premuto="$emit('bottone-premuto')">

    </Bottoniera>
  </cv-content>
</template>

<script>
import Bottoniera from "@/components/Bottoniera";
import Management from '@carbon/icons-vue/es/inventory-management/16';

export default {
  name: "Terzisti",
  components: { Bottoniera },
  data: function() {
    return {
      svg_fornitore: Management,
      modello_comune: "Ferrara",
      comuni: [
        {
          value: "1",
          label: "Ravenna",
          name: "1",
        },
        {
          value: "2",
          label: "Ferrara",
          name: "2",
        },
        {
          value: "3",
          label: "Forlì",
          name: "3",
        }
      ],
    }
  },
  methods: {
    cambiamento: function (evento) {
      console.log(evento);
    }
  }
}
</script>

<style scoped>

</style>